module.exports = __webpack_public_path__ + "static/img/delivery-detail-header.af14af6a.jpg";